import axios from 'axios';

import { baseURL } from '../Utils/constants/constant';

const Api = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const ImgAPI = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});
export default Api;